export default "__VITE_ASSET__CNNKC0e5__"